// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/scss/layout.scss
// module id = 339
// module chunks = 0